import { Tooltip } from "@heroui/react";
import React from "react";

type SectionEditableFieldProps = {
  label: string;
  ComponentToRender: React.ReactNode;
  editMode: boolean;
  type?: any;
  isLoading?: boolean;
  value?: any;
  children?: React.ReactNode;
  mask?: any;
  indentation?: string | number | null;
  style?: string;
  onChange: any;
  link?: string;
  linkTooltip?: string;
};

export const SectionEditableField = React.memo(
  ({
    label,
    ComponentToRender,
    editMode,
    children,
    indentation,
    style,
    link,
    linkTooltip,
  }: SectionEditableFieldProps) => (
    <div
      className={`flex flex-wrap items-center justify-between p-2.5 text-sm ${
        style !== "bold" && "bg-secondary-moss font-bold !important"
      } ${indentation ? "ml-" + indentation : ""}`}
    >
      {!editMode && (
        <p>
          {link ? (
            <Tooltip content={linkTooltip}>
              <a
                href={link}
                className="font-medium text-moss-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            </Tooltip>
          ) : (
            label
          )}
        </p>
      )}
      {children ? children : ComponentToRender}
    </div>
  ),
);
